import { RoomParams } from "../types";

const HOST_PATH = "/app/telehealth-v2/room";
const GUEST_PATH = "/public/telehealth-v2/join";

export function buildHostUrl(p: Omit<RoomParams, "role" | "displayName"> & { displayName: string }) {
  // Hosts get `skipPreflight=1` by default — the link is meant for rejoining
  // an existing meeting, so the provider doesn't need another mic/cam check.
  // The literal "1" matches what parseRoomParams expects. Callers can opt
  // out by passing `skipPreflight: false`.
  const skip = p.skipPreflight === false ? undefined : "1";
  return buildUrl(HOST_PATH, {
    ...p,
    role: "host",
    skipPreflight: skip,
  });
}

export function buildGuestUrl(p: Omit<RoomParams, "role" | "displayName"> & { displayName: string }) {
  return buildUrl(GUEST_PATH, { ...p, role: "guest" });
}

function buildUrl(
  path: string,
  params: Record<string, string | number | boolean | undefined>
) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") search.set(k, String(v));
  });
  return `${path}?${search.toString()}`;
}

export function parseRoomParams(search: URLSearchParams): RoomParams {
  return {
    room: search.get("room") ?? "",
    role: (search.get("role") as RoomParams["role"]) ?? "guest",
    displayName: search.get("displayName") ?? search.get("name") ?? "Guest",
    appointmentId: search.get("appointmentId") ?? undefined,
    patientId: search.get("patientId") ?? undefined,
    startTime: search.get("startTime") ?? undefined,
    skipPreflight: search.get("skipPreflight") === "1",
  };
}
